<template>
  <div>
    <div v-if="loading">

      <loader-appie/>

    </div>
<!--    <sidebar-home-one :menuItems="navs" :side="SideMenu" :sidebar="sidebar" @toggleSidebar="toggleSidebar"/>-->

<!--    <header-home-two :custCare="customerCare" :menuItems="navs" :side="SideMenu" :titleWordd="titleWord"-->
<!--                     @toggleSidebar="toggleSidebar"/>-->

    <section id="testimonial" class="appie-testimonial-2-area mb-90">

      <div v-if="!loading" class="container ">
        <div>
          <!--          <button @click="goBack" class="backbtn"><span style="color: black">⬅️ </span></button>-->
          <!--          <span @click="goBack">☚</span>-->
        </div>

        <div class="row">
          <div class="col-md-3 whitebackground menudiv" >
            <menubar @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"
                     :menuItems="navs"/>
          </div>
          <div class="col-md-9 graybackground contentdiv">
            <div class="row mt-3">
              <div>

                <Commonprofile/>

              </div>
              <div>
                <div class="temptcard mt-2">
                  <div class="row">
                    <div class="col-md-8">
                      <div>


                        <div class="row">
                          <div class="col-12 col-lg-12 col-sm-12">
                            <div style="text-align: center;font-size: 20px">
                              <span :style="{ color:setTextColor}">{{ title }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class=" col-12 col-md-6">
                            <span>Please fill (*) required field in below</span>
                          </div>
                          <div class="col-12 col-md-6" style="text-align: end">
                            <!--                <button v-for="(lang, labelIndex) in language" :key="labelIndex"-->
                            <!--                        :style="{ backgroundColor: selectlang === labelIndex ? 'yellow' : (selectlang === labelIndex ? '' : ''),width: '100%',borderColor: 'lightgray', color: 'black' }"-->
                            <!--                        class="btn " type="button"-->
                            <!--                        @click="selectlang = labelIndex"-->
                            <!--                >{{ lang }}-->
                            <!--                </button>-->
                            <button v-for="(lang, index) in language" :key="index"
                                    :style="{ backgroundColor: index === selectlang ? '#4D5BE1' : '',color: index === selectlang ? 'white' : '' }"
                                    class="langbtn" @click="changeLanguage(index)">
                              {{ lang }}
                            </button>
                          </div>
                        </div>
                        <!--<br>-->
                        <br>

                        <!--            {{RegisterData}}-->

                        <!--            <form ref="form" class="row g-3" novalidate >-->
                        <!--            <form  class="row g-3" >-->
                        <b-form @submit.prevent="submitForm">
                          <div class="row">
                            <div v-for="(filedsData,index) in fileds" :key="index" ref="invalidFieldDivs" class="">
                              <Textview :id="filedsData.name" v-model="filedsData.id" :fieldsData="filedsData"
                                        :selectlang="selectlang"></Textview>

                              <Inputfield
                                  v-if="filedsData.fieldType=='EditText' &&filedsData.inputType!='textMultiLine' && filedsData.visible==1"
                                  :id="filedsData.name"
                                  v-model="filedsData.id" :fieldsData="filedsData" :selectlang="selectlang"></Inputfield>
                              <Textareafield
                                  v-if="filedsData.fieldType=='EditText'&&filedsData.inputType=='textMultiLine'&& filedsData.visible==1"
                                  :id="filedsData.name"
                                  v-model="filedsData.id" :fieldsData="filedsData"
                                  :selectlang="selectlang"></Textareafield>
                              <Selectfield v-if="filedsData.fieldType === 'Spinner'&& filedsData.visible==1" :id="filedsData.name"
                                           :ref="'selectField_' + filedsData.name" v-model="filedsData.id"
                                           :fieldsData="filedsData" :selectlang="selectlang" @districtChange="districtChange"
                                           @targetfield="targetfield"></Selectfield>
                              <!--                                <MultiSelectfield  :ref="filedsData.name" :id="filedsData.name"  v-if="filedsData.fieldType=='MultiSpinner' && filedsData.visible==1" :fieldsData="filedsData" v-model="filedsData.id" :selectlang="selectlang" @multiChange="multiChange"-->
                              <!--                                                   :readonly="restrictfield.includes(filedsData.name)"    ></MultiSelectfield>-->

                              <MultiSelectfield v-if="filedsData.fieldType=='MultiSpinner' && filedsData.visible==1"
                                                :id="filedsData.name"
                                                :ref="filedsData.name"
                                                v-model="filedsData.id" :fieldsData="filedsData" :selectlang="selectlang"
                                                @multiChange="multiChange" @targetfield="targetfield"></MultiSelectfield>
                              <!--                                <span class="text-danger"  v-if="restrictfield.includes(filedsData.resetField) && filedsData.fieldType=='MultiSpinner' && filedsData.visible==1 && filedsData.visible==1" >( {{ filedsData.error[selectlang] }} )</span>-->

                              <checkbox v-if="filedsData.fieldType === 'CheckBox' && filedsData.visible == 1" :id="filedsData.name"
                                        v-model="filedsData.id" :fieldsData="filedsData" :selectlang="selectlang"
                                        @wtsappupdate="wtsappupdate"></checkbox>
                              <!--                <Groupedittext :fieldsData="filedsData" v-model="filedsData.id" :selectlang="selectlang"></Groupedittext>-->
                              <div
                                  v-if="filedsData.fieldType =='GroupEditText' && (!filedsData.hasOwnProperty('visible') || filedsData.visible == 1)"
                                  class="row">

                                <label
                                    v-if="filedsData.fieldType=='GroupEditText' && (!filedsData.hasOwnProperty('visible') || filedsData.visible == 1)"
                                    v-html="filedsData.label[selectlang]"></label>

                                <div v-for="(subfield, index) in filedsData.field" :key="index" class="col-md-6">
                                  <Groupedittext :id="filedsData.name" v-model="filedsData.field[index].id" :fieldsData="subfield"
                                                 :selectlang="selectlang"></Groupedittext>

                                </div>
                                <span
                                    v-if="invalidRangeFieldNames.includes(filedsData.name) && filedsData.visible == 1 &&  parseInt(filedsData.field[1].id) < parseInt(filedsData.field[0].id) "
                                    class="text-danger">( {{
                                    filedsData.field[0].validationRangeText[selectlang]
                                  }} )</span>
                              </div>
                              <Radiofield
                                  v-if="filedsData.fieldType == 'GroupCheckBox' && filedsData.visible==1 && filedsData.selectionType == 'single'"
                                  v-model="filedsData.id" :fieldsData="filedsData" :selectlang="selectlang"></Radiofield>
                              <!--                <Btnsave :fieldsData="filedsData" v-model="filedsData.id" :selectlang="selectlang"></Btnsave>-->
                              <Groupcheckbox
                                  v-if="filedsData.fieldType === 'GroupCheckBox' &&  filedsData.visible == 1 &&  filedsData.selectionType =='multiple'"
                                  v-model="filedsData.id" :fieldsData="filedsData" :selectlang="selectlang"
                                  @multifield="multifield"></Groupcheckbox>
                              <!--               {{filedsData}}-->
                              <MultiAddView v-if="filedsData.fieldType === 'MultiAddView' &&  filedsData.visible == 1 "
                                            v-model="filedsData.id" :fieldsData="filedsData" :selectlang="selectlang"></MultiAddView>
                              <VerifyView v-if="filedsData.fieldType === 'VerifyView' &&  filedsData.visible == 1 "
                                          v-model="filedsData.id" :fieldsData="filedsData" :selectlang="selectlang"
                                          @verifybtndone="verifybtndone"></VerifyView>
                              <span
                                  v-if="invalidFieldVerifyBtnName.includes(filedsData.name) && isbtnverify != 1 &&  filedsData.visible == 1"
                                  class="text-danger">
                 {{ filedsData.btnAction.verifyText[selectlang] }}
                 </span>
                              <FileUpload v-if="filedsData.fieldType === 'FileUpload' &&  filedsData.visible == 1 "
                                          v-model="filedsData.id" :fieldsData="filedsData" :selectlang="selectlang"></FileUpload>
                              <span v-if="invalidFieldNames.includes(filedsData.name)&& filedsData.id =='' && filedsData.visible == 1"
                                    class="text-danger">( {{
                                  filedsData.error[selectlang]
                                }} )</span>
                              <span
                                  v-if="spinnerinvalidFieldNames.includes(filedsData.name)&& filedsData.id == null && filedsData.visible == 1"
                                  class="text-danger">( {{
                                  filedsData.error[selectlang]
                                }} )</span>

                            </div>
                            <!--              <div ref="myDiv" tabindex="0" @focus="handleFocus" :class="{ focused: isFocused }">Focusable Div</div>-->
                          </div>
                          <div class="row" style="margin-top: 15%;" >
                            <div class="col-12 cardDiv">
                              <div class="card" style="border: unset">
                                <div class="card-body">
                                  <div v-for="(buttonData, index) in buttonsData" :key="index + '-' + buttonData" class="buttonDiv ">
                                    <!--              <button>{{buttonData.dialogue}}</button>-->
                                    <div v-if="buttonData.visible == '1'">
                                      <div v-if="PostJobModal">
                          <span v-b-modal.modal-center class="btn btn-primary " type="submit"><span
                              v-html="buttonData.title[selectlang]"></span></span>
                                      </div>
                                      <div v-else>

                                        <button class="btn btn-primary " type="submit"><span
                                            v-html="buttonData.title[selectlang]"></span></button>
                                        <!--                  <button class="btn btn-primary " type="submit" @click="formconfirm()"><span v-html="buttonData.title[selectlang]"></span></button>-->
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </b-form>
                        <!--            <input ref="myInput" type="text" />-->
                        <!--            <v-select ref="mySelect" :items="items" label="Select" v-model="selectedItem"></v-select>-->
                        <!--              <button class="btn btn-primary " type="button" @click="DataSave" >save</button>-->
                        <!--            </form>-->

                      </div>

                    </div>
                    <div class="col-md-4 kycimage" style="margin:auto">
<!--                      <div>-->
                        <img src="https://d2hy6ree306xec.cloudfront.net/bg-image.webp">
<!--                      </div>-->


                    </div>

                  </div>


                </div></div>
            </div></div></div>


      </div>

      <div>
        <b-modal id="modal-center" v-model="confirmModal" centered no-close-on-backdrop title="BootstrapVue">
          <div v-for="(buttonData, index) in buttonsData" :key="index + '-' + buttonData">
            <div v-if="buttonData.visible == '1'" class="modal-content-container">
              <div class="centered-content">
                <span v-html="buttonData.dialogue.content[selectlang]"></span>
                <br>
                <br>
                <div class="row">
                  <div class="col-6">
                    <button class="btn fontunset" style="float: right;background: rgb(197 195 195);color: black;border: unset" @click="closeFunc()">
                      <!--                      <span :style="{ backgroundColor: buttonData.dialogue.bgColor }"  v-html="buttonData.dialogue.negative[selectlang]"></span>-->
                      <span v-html="buttonData.dialogue.negative[selectlang]"></span>
                    </button>
                  </div>
                  <div class="col-6">
                    <!--                    {{buttonData.url}}-->
                    <button class="btn btn-primary" @click="DataSave(buttonData.url)">
                      <!--                      <span :style="{ backgroundColor: buttonData.dialogue.bgColor }"  v-html="buttonData.dialogue.positive[selectlang]"></span>-->
                      <!--                      {{buttonData.dialogue}}-->
                      <span v-html="buttonData.dialogue.positive[selectlang]"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>

      <div>
        <b-modal id="modal-center1" centered title="BootstrapVue">
          <div class="row">
            <!-- First Card Row -->
            <div v-for="(customerCareData,index) in customerCare" :key="index" class="col-12 col-lg-12 col-md-12 mb-4">
              <span v-html="stripTags(customerCareData.label)"></span>
              <div class="card" >
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-2 col-lg-2 col-md-2">
                      <div class="d-flex justify-content-center align-items-center h-100">
                        <i aria-hidden="true" class="fa fa-phone flipped" style="background: white;"></i>
                      </div>
                    </div>
                    <div class="col-8 col-lg-8 col-md-8">
                      <div class="d-flex flex-column justify-content-center h-100">
                        <span>{{ customerCareData.name }}</span>
                        <span v-html="customerCareData.description"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </section>

    <div class="back-to-top back-to-top-2">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>

  </div>
</template>


<script>

import CryptoJS from 'crypto-js';

import video_bg_thumb from "@/assets/images/video-thumb-1.jpg"
import hero_img from '@/assets/images/hero-thumb-3.png'
// import HeaderHomeTwo from '../menu.vue'
// import HeaderHomeTwo from '../HomePage/Header.vue'
// import SidebarHomeOne from "@/components/HomeOne/SidebarHomeOne.vue";
import Inputfield from '../Fields/inputText.vue';
import Textareafield from '../Fields/textArea.vue';
import Selectfield from '../Fields/select.vue';
import MultiSelectfield from '../Fields/multiSelect.vue';
import checkbox from '../Fields/checkBox.vue';
import Textview from '../Fields/textView.vue';
import Groupedittext from '../Fields/groupEditText.vue';
import Radiofield from '../Fields/radio.vue';
import Groupcheckbox from '../Fields/groupCheckBox.vue';
import MultiAddView from '../Fields/multiAddView.vue';
import VerifyView from '../Fields/emailcheck.vue';
import FileUpload from '../Fields/fileupload.vue';
// import Btnsave from '../Fields/btnSave.vue';
import Ripple from 'vue-ripple-directive'


import {callAxiosWithConfig, callAxiosWithHeader} from "@/main";
// import {right} from "core-js/internals/array-reduce";
// import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import {BFormGroup, BFormInput, BFormTags, BInputGroup} from 'bootstrap-vue'
import {BForm} from 'bootstrap-vue'

import {Validator} from 'vee-validate';
import LoaderAppie from "@/components/LoaderAppie.vue";

import Commonprofile from "@/components/HomePage/commonprofilediv.vue";
import Menubar from "@/components/HomePage/menu.vue";

// import {BFormCheckbox} from "bootstrap-vue";
// import {BFormCheckbox} from "bootstrap-vue";
// import {trim} from "core-js/internals/string-trim";
// import Vue from "vue";

// import vSelect from "vue-select";
// import { ValidationProvider, ValidationObserver } from "vee-validate";


export default {
  props: {
    section_heading: {
      type: String,
    },
    more_heading: {
      type: String
    },
    description: {
      type: String
    },
    grid_items: {
      type: Array,
    }
  },
  components: {
    Menubar, Commonprofile,
    // SidebarHomeOne,
    LoaderAppie,
    BForm,
    // HeaderHomeTwo,
    Inputfield,
    Textareafield,
    Selectfield,
    MultiSelectfield,
    checkbox,
    Textview,
    Groupedittext,
    Radiofield,
    Groupcheckbox,
    MultiAddView,
    VerifyView,
    FileUpload,
    // Btnsave,


    // SidebarHomeOne,
  },
  data() {
    return {
      isFocused: false,
      showToastVerifytoaster: false,

      isbtnverify: 0,
      loading: true,
      restrictfield: [],
      invalidFieldNames: [],
      spinnerinvalidFieldNames: [],
      invalidFieldVerifyBtnName: [],
      invalidRangeFieldNames: [],
      onchangeRangeFieldNames: [],
      showerror: false,
      selectedItem: null,
      targetFieldArray: [],
      emptyFieldArray: [],
      SideMenu: {},
      titleWord: '',
      customerCare: {},
      PostJobModal: false,
      ErrorMessage: null,
      ErrorMessage1: '',
      showElement: {},
      buttonsData: {},
      myArray: [],
      SingleArray: [],
      ContactArray: [],
      validation: false,
      DataArray: {},
      stopLoop: false,
      tags: [],
      dirty: false,
      // codeValidation,
      selectedGender: {},
      modalVisible: false,
      selectlang: 0,
      JobTitle: '',
      District: [],
      VisibleArray: '',
      checkedItems: {},
      is_validd: true,
      confirmModal: false,
      formData: {
        firstName: '',
        lastName: '',
        username: '',
        city: '',
        state: '',
        zip: '',
        agreeToTerms: false,
      },

      setTextColor: '',
      filedsID: '',
      fileds: '',
      title: '',
      RegisterData: '',
      language: [],
      urlData: '',
      dyncheckbox: {},
      ViewPosttitle: '',
      modifiedString: '',
      sidebar: false,
      filteredCities: [],
      originalFieldsData: [],
      navs: [
        {
          // name:'contact',
          name: 'Home',
          path: '/home-page'
        },
        {
          name: 'Profile',
          childrens: [
            {
              // name:'Home 1',
              name: 'Update KYC',
              path: '/'
            },
            {
              // name:'Home 2',
              name: 'Update Profile',
              path: '/home-two'
            },
            {
              // name:'Home 3',
              name: 'View Profile',
              path: '/home-three'
            },
            {
              // name:'Home 4',
              name: 'Viewed Profiles',
              path: '/home-four'
            },
            // {
            //   // name:'Home 5',
            //   name: 'Change Mobile Number',
            //   path: '/home-five'
            // },

          ],
        },

        {
          // name:'contact',
          name: 'Customer Care',
          path: '/contact'
        },

      ],
      hero_img: hero_img,
      video_bg_thumb: video_bg_thumb
    }
  },

  mounted() {
    document.addEventListener('scroll', this.topToBottom);
    // this.focusSelect();
  },

  async created() {

    if (this.$route.query.page) {
      const pageurl = this.$route.query.page;
      const decryptedString = this.decryptUrl(pageurl);
      this.modifiedString = decryptedString;
      // this.modifiedString="https://jobspro.nithrajobs.com/api/register/form/fields";
      // this.modifiedString = "https://jobspro.nithrajobs.com/api/post/form/fields";
      // this.modifiedString="https://jobspro.nithrajobs.com/api/upload/Form/Fields";
      // this.modifiedString="https://jobspro.nithrajobs.com/api/home/nearByCompanies";
      //   alert(this.modifiedString);
      // this.EditId = this.$route.query.id;
      // this.decryptedValue = this.Decrypt(this.encryptedParam);
      // this.modifiedString = this.decryptedValue.replace(/-/g, '/');
      // }

      const RegisterData = await callAxiosWithConfig(this.modifiedString, '', 'post');
      // console.log('RegisterData', RegisterData);

      this.loading = false,

          this.RegisterData = RegisterData;
      this.title = RegisterData.title;
      if (Object.prototype.hasOwnProperty.call(RegisterData, 'language')) {
        this.language = RegisterData.language;
      } else {
        this.language = ["Eng", "தமிழ்"];
      }
      this.setTextColor = RegisterData.setTextColor;
      this.fileds = RegisterData.fileds;
      this.buttonsData = RegisterData.buttons;

      // this.fileds.forEach(obj => {
      //   if (obj.resetField) {
      //     this.targetFieldArray.push(obj.name);
      //   }
      // });
      // this.fileds.forEach(item => {
      //   if (this.targetFieldArray.includes(item.name) && item.id == '') {
      //     this.emptyFieldArray.push(item.resetField,item.name);
      //   }
      //   else {
      //     this.fileds = RegisterData.fileds;
      //   }
      // });
      //
      // this.emptyFieldArray.forEach(fieldName => {
      //   const fieldToUpdate = this.fileds.find(field => field.name === fieldName &&  field.targetField !='');
      //   // const targetField = fieldToUpdate["targetField"];
      //   if (fieldToUpdate) {
      //     // this.restrictfield.push(field.name);
      //     this.restrictfield.push(fieldName);
      //     // fieldToUpdate["string-array"] = '';
      //   } else {
      //     console.log(`Field '${fieldName}' has a non-empty targetField.`);
      //   }
      // });
      //       console.log('targetFieldArray',this.targetFieldArray);
      //       console.log('emptyFieldArray',this.emptyFieldArray);
      // console.log(this.fileds);

// Now this.DataArray will contain values from RegisterData.fields mapped by field name
      // console.log('hello',this.DataArray);
      this.SideMenu = JSON.parse(localStorage.getItem("SideMenu"));
      this.titleWord = JSON.parse(localStorage.getItem("titleWord"));
      this.customerCare = JSON.parse(localStorage.getItem("customerCare"));

      // console.log(this.SideMenu)
      // console.log(this.titleWord)
      // console.log(this.customerCare)
      this.$emit("tempData", this.SideMenu);
      this.$emit("title", this.titleWord);
      this.$emit("customerCare", this.customerCare);
      // console.log(this.buttonsData)


      this.initializeOriginalData();
    }
  },

  computed: {
    validationErrors() {
      return Validator.errors;
    },

    state() {
      // Overall component validation state
      return this.dirty ? this.tags.length > 2 && this.tags.length < 9 : null
    },
  },
  watch: {
    tags() {
      // Set the dirty flag on first change to the tags array
      this.dirty = true
    },
  },
  directives: {
    Ripple,
  },

  methods: {
    targetfield(value) {
// alert(value);
      this.emptyFieldArray = [];
      if (value != '' && value != null) {

        let getfield = this.fileds.find(item => item.targetField == value);
        if (getfield) {
          this.targetFieldArray.push(getfield.targetField);
        }
      }


      if (this.targetFieldArray.length > 0) {
        this.fileds.forEach(item => {
          if (this.targetFieldArray.includes(item.name) && item.id == '') {
            this.emptyFieldArray.push(item.name);
          }
          // else if (this.targetFieldArray.includes(item.name) && item.id != '') {
          //
          //
          //  }

        });
      }
      // console.log('this.emptyFieldArray', this.emptyFieldArray)

      if (this.emptyFieldArray.length > 0) {
        this.fileds.forEach(field => {
          if (this.emptyFieldArray.includes(field.targetField) && field.name != 'person_proof_type') {
            field["string-array"] = [];
          }
        });

      }

      //
      // if (this.emptyFieldArray.length > 0) {
      //   this.emptyFieldArray.forEach(fieldName => {
      //     const fieldToUpdate = this.fileds.find(field => field.targetField === fieldName);
      //     if (fieldToUpdate) {
      //       this.fileds.forEach(item => {
      //         if (item.targetField === fieldName) {
      //           item["string-array"] = [];
      //         }
      //       });
      //     }
      //   });
      // }
    },
    goBack() {
      this.$router.go(-1); // Go back to the previous page
    },
    preventDisabledKeyEvents(event) {
      if (this.disabled && event.key === 'ArrowDown') {
        event.preventDefault();
      }
    },
    preventDisabledSelect(event) {
      // alert('hfgfh');
      if (this.disabled) {
        event.preventDefault();
      }
    },
    shouldShowMultiSelectField() {
      let shouldShow = true;
      this.fileds.forEach(obj => {
        if (obj.resetField) {
          this.targetFieldArray.push(obj.name);
        }
      });
      this.fileds.forEach(item => {
        if (this.targetFieldArray.includes(item.name) && item.id == '') {
          this.emptyFieldArray.push(item.resetField, item.name);
        }

      });

      this.emptyFieldArray.forEach(fieldName => {
        const fieldToUpdate = this.fileds.find(field => field.name === fieldName && field.targetField != '');
        // const targetField = fieldToUpdate["targetField"];
        if (fieldToUpdate) {
          shouldShow = false;
          // fieldToUpdate["string-array"] = '';

        } else {
          console.log(`Field '${fieldName}' has a non-empty targetField.`);
        }
      });
      return shouldShow;
    },

    wtsappupdate(status, targetValue, targetField) {
      // alert(status)
      if (status == 1) {
        // alert(1)
        this.fileds.find(item => item.name == targetField)["id"] = targetValue;
      } else {
        // alert(2)
        this.fileds.find(item => item.name == targetField)["id"] = "";
      }


    },


    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },

    toaster() {
      // alert('yes');
      this.showToastVerifytoaster = true;

      // Hide the toast after a certain duration
      setTimeout(() => {

        this.showToastVerifytoaster = false;
      }, 3000); // Adjust the duration as needed
    },
    // checkrange() {
    //   this.fileds.forEach((obj, index) => {
    //     if (obj.fieldType === "GroupEditText" && index > 0 && obj.field.length >= 2) {
    //       // Check if the id of the second field is less than the id of the first field
    //       if (obj.field[1].id < obj.field[0].id) {
    //         // If the condition is met, add the name of the field to the 'onchangeRangeFieldNames' array
    //         this.onchangeRangeFieldNames.push(obj.name);
    //       }
    //     }
    //   });
    //   if (this.onchangeRangeFieldNames.length > 0) {
    //     return 1;
    //   } else {
    //     return 0;
    //   }
    // },
    verifybtndone(btnstaus) {
      if (btnstaus == 1) {
        this.isbtnverify = 1;
      } else {
        this.isbtnverify = 0;
      }

    },
    // handleFocus() {
    //   console.log("Div is focused!");
    //   this.isFocused = true;
    //   this.$nextTick(this.scrollToDiv);
    // },
    scrollToFirstInvalidFieldDiv(InvalidFiledArray) {

      // Find the first invalid field div
      let firstInvalidFieldDiv = '';
      firstInvalidFieldDiv = this.$refs.invalidFieldDivs.find((_, index) => {
        const fieldName = this.fileds[index].name;
        return (
            InvalidFiledArray.includes(fieldName)

        );
      });

      // Scroll to the div if found
      if (firstInvalidFieldDiv) {
        // console.log('firstInvalidFieldDiv',this.invalidFieldNames)
        firstInvalidFieldDiv.scrollIntoView({behavior: 'smooth', block: 'center',});
      }
    },

    submitForm() {
      // this.$refs.myDiv.focus();
      // alert('dd')
      // setTimeout(() => {
      //   const searchInput = this.$refs['selectField_jobtitle_id'][0].$refs.search
      //   if (searchInput) {
      //     searchInput.focus();
      //   }
      // }, 1);
      let InvalidFiledArray = [];
      this.invalidFieldNames = [];
      this.spinnerinvalidFieldNames = [];
      this.invalidFieldVerifyBtnName = [];
      this.invalidRangeFieldNames = [];
      this.fileds.forEach((obj, index) => {
        if (obj.required == 1 && obj.id == '' && obj.fieldType != 'TextView') {
          this.invalidFieldNames.push(obj.name);
          InvalidFiledArray.push(obj.name);
          // const typeOfId = typeof obj.id;

          // const selectField = this.$refs[obj.name]?.$el;
          // if (selectField) {
          //   this.showerror = true;
          // }

        }
        if (obj.required == 1 && obj.id == null && obj.fieldType == 'Spinner') {
          this.spinnerinvalidFieldNames.push(obj.name);
          InvalidFiledArray.push(obj.name);
        }

        if (obj.required == 1 && obj.id != '' && obj.fieldType == 'VerifyView') {
          if (this.isbtnverify != 1) {
            // alert('in')
            InvalidFiledArray.push(obj.name);
            this.invalidFieldVerifyBtnName.push(obj.name);
          }
        }
        if (obj.visible == 0 && obj.id != '' && obj.fieldType == 'VerifyView') {
          obj.id = '';
        }

        if (obj.fieldType === "GroupEditText" && index > 0 && parseInt(obj.field[1].id) < parseInt(obj.field[0].id)) {
          // console.log( 'field1',obj.field[0].id);
          // console.log( 'field2',obj.field[1].id);
          // this.showerror = true;
          // Check if id of the second field is less than id of the first field
          this.invalidRangeFieldNames.push(obj.name);
          InvalidFiledArray.push(obj.name);
          // InvalidFiledArray.push(obj.field[1].validationRangeText[0]);
        }

      });

      // console.log('InvalidFiledArray', this.InvalidFiledArray);
      //  console.log(this.invalidRangeFieldNames);
      if (InvalidFiledArray.length == 0) {

        // let transformedArray = {};
        // this.fileds.forEach(obj => {
        //   if (obj.fieldType === 'GroupEditText') {
        //     obj.field.forEach(field => {
        //       transformedArray[field.name] = field.id;
        //     });
        //   } else {
        //     let values = '';
        //     if (Array.isArray(obj.id)) {
        //       values = obj.id.join(',');
        //     } else {
        //       values = obj.id;
        //     }
        //     transformedArray[obj.name] = values;
        //   }
        // });
        // console.log("hsagdhsdh",transformedArray);
        // alert('done');
        this.formconfirm();
      } else {
        this.scrollToFirstInvalidFieldDiv(InvalidFiledArray);
      }

    },
    // scrollToDiv() {
    //   if (this.myDiv.selectField) {
    //     this.$refs.myDiv.$el.scrollIntoView({ behavior: "smooth", block: "start" });
    //   }
    //
    //   // this.$refs.myDiv.scrollIntoView({ behavior: "smooth", block: "start" });
    // },

    async DataSave(formurl) {
      let transformedArray = {};
      // this.fileds.forEach(obj => {
      //   if(obj.fieldType =='GroupEditText'){
      //
      //   }
      //      let  values='';
      //     if (Array.isArray(obj.id)) {
      //        values=obj.id.join(',');
      //     } else {
      //         values=obj.id;
      //      }
      //   transformedArray[obj.name] =values;
      // });

      this.fileds.forEach(obj => {
        if (obj.fieldType === 'GroupEditText') {
          obj.field.forEach(field => {
            transformedArray[field.name] = field.id;
          });
        } else {
          let values = '';
          if (Array.isArray(obj.id)) {
            values = obj.id.join(',');
          } else {
            values = obj.id;
          }
          transformedArray[obj.name] = values;
        }
      });

      // console.log("hsagdhsdh",transformedArray);
      // console.log("formurl",formurl);


      // const RegisterData = await callAxiosWithConfig(formurl, transformedArray, 'post');
      const RegisterData = await callAxiosWithHeader(formurl, transformedArray, 'post', {
        'Content-Type': 'multipart/form-data'
      });
      // console.log('register',RegisterData);
      this.confirmModal = false;
      // console.log('register',RegisterData);
//
      const url = RegisterData.url;
      const inputString = RegisterData.activity;
      const lastPart = inputString.split('.').pop();

      if (lastPart === 'Employer_Dynamic_Home_Activity') {
        const desiredPath = url;
        if (desiredPath == "https://jobspro.nithrajobs.com/api/post/view/dashboard") {
          const encryptedString = this.encryptUrl(url);
          await this.$router.push(`/view-post?page=${encodeURIComponent(encryptedString)}`);
        } else {
          const encryptedString = this.encryptUrl(url);
          await this.$router.push(`/home-page?page=${encodeURIComponent(encryptedString)}`);
        }

      } else if (lastPart === 'Employer_Near_By_Company') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/near-by-company?page=${encodeURIComponent(encryptedString)}`);
      } else if (lastPart === 'ViewCandidate_List') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/viewed-employer-list?page=${encodeURIComponent(encryptedString)}`);
      }
      // else{
      //   window.location.href = `/view-post?page=${encodeURIComponent(encryptedString)}`;
      // }
// console.log(url)

    },
    closeFunc() {
      this.confirmModal = false;
    },

    initializeOriginalData() {
      // Deep copy the original data from this.fields to originalFieldsData
      this.originalFieldsData = JSON.parse(JSON.stringify(this.fileds));
    },
    changeLanguage(lang) {
      this.selectlang = lang;
    },

    multiChange(districtid, action, fieldname, resetField, visibilityChanges, requiredChanges) {
      if (resetField != '') {
        // ------#### for unselect field-----
        // const seledtedid = this.fileds.find(item => item.name === resetField);
        // ------####-----
        // const selObject = this.originalFieldsData.find(item => item.name === resetField);
        let selObject = this.originalFieldsData.filter(sel => resetField.includes(sel.name));
        selObject.forEach(sel => {
          if (sel && sel["string-array"]) {
            // alert('in')
            // console.log('Initial "string-array":', selObject["string-array"]);
            // Filter the original array
            // ------#### for unselect field-----
            // const filteredArray = selObject["string-array"].filter(sel => sel.filter === districtid);
            // ------####-----

            const filteredArray = sel["string-array"].filter(item => districtid.includes(item.filter));
            // ------for single---
            // this.fileds.find(item => item.name === resetField)["string-array"] = filteredArray;
            // if (action == 'new') {
            //   this.fileds.find(item => item.name === resetField)["id"] = "";
            // }
            // ------for single---

            let filteredItems = this.fileds.filter(item => resetField.includes(item.name));

            filteredItems.forEach(item => {
              if (item && item["string-array"]) {
                item["string-array"] = filteredArray;
              }
            });


            if (action == 'new') {
              let emptyfilteredItems = this.fileds.filter(item => resetField.includes(item.name));
              emptyfilteredItems.forEach(item => {
                if (item && item["string-array"]) {
                  // Set the "string-array" property for each filtered item
                  item["id"] = "";
                }
              });
            }

          }
        });
      }


      visibilityChanges.forEach(change => {
        const [action, fieldNames] = change.split(':');
        const affectedFields = fieldNames.split(',');


        this.fileds.forEach(field => { // Accessing fields from 'this' object
          if (affectedFields.includes(field.name)) {
            field.visible = (action === 'show') ? 1 : 0;
            // console.log(field.name, field.visible);
          }
        });
      });
      requiredChanges.forEach(change => {
        const [action, fieldNames] = change.split(':');
        const affectedFields = fieldNames.split(',');


        this.fileds.forEach(field => { // Accessing fields from 'this' object
          if (affectedFields.includes(field.name)) {
            field.required = (action === 'required') ? 1 : 0;
            // console.log(field.name, field.visible);
          }
        });
      });

    },
    multifield(showhideinput) {
      showhideinput.forEach(change => {
        const [action, fieldNames] = change.split(':');
        const affectedFields = fieldNames.split(',');


        this.fileds.forEach(field => { // Accessing fields from 'this' object
          if (affectedFields.includes(field.name)) {
            field.visible = (action == 'show') ? 1 : 0;
            field.required = (action == 'show') ? 1 : 0;
            // console.log(field.name, field.visible);
          }
        });
      });
      // if(value ==true) {
      //   this.fileds.forEach(field => { // Accessing fields from 'this' object
      //     if (visible.includes(field.name)) {
      //       field.visible = 1;
      //       field.required = 1;
      //       // console.log(field.name, field.visible);
      //     }
      //   });

    },
    districtChange(districtid, action, fieldname, resetField, visibilityChanges, requiredChanges, autoReflectField) {
      // Declare value1 here to make it accessible within the function
      let districtid1 = districtid;
      // console.log(typeof districtid);
      if (typeof districtid1 === 'number') {
        districtid = districtid1.toString();
      } else {
        districtid = districtid1;
      }

      if (resetField) {
        // const selObject = this.originalFieldsData.find(item => item.name === resetField);
        let selObject = this.originalFieldsData.filter(sel => resetField.includes(sel.name));
        // console.log('selObject',selObject)
        selObject.forEach(sel => {
          if (sel && sel["string-array"]) {
            // console.log('Initial "string-array":', selObject["string-array"]);
            // Filter the original array
            // const filteredArray = selObject["string-array"].filter(sel => sel.filter == districtid);
            const filteredArray = sel["string-array"].filter(item => item.filter == districtid);

            // const filteredArray = sel["string-array"].filter(item => districtid.includes(item.filter));
            // const selectfilteredIds = filteredArray.map(sel => sel.id);

            // console.log('selectfilteredIds',selectfilteredIds);

            // Update the "string-array" property in this.fields directly
            // this.fileds.filter(item => resetField.includes(item.name))["string-array"]=filteredArray;

            let filteredItems = this.fileds.filter(item => resetField.includes(item.name));
// Iterate over each filtered item
//             console.log('filteredItems',filteredItems);
            filteredItems.forEach(item => {
              if (item && item["string-array"]) {
                // Set the "string-array" property for each filtered item
                item["string-array"] = filteredArray;
              }
            });

            if (action == 'new') {
              // this.fileds.find(item => item.name === resetField)["id"]="";
              let emptyfilteredItems = this.fileds.filter(item => resetField.includes(item.name));
              // console.log('emptyfilteredItems',emptyfilteredItems);
// Iterate over each filtered item
              emptyfilteredItems.forEach(item => {
                if (item && item["string-array"]) {
                  // Set the "string-array" property for each filtered item
                  item["id"] = "";
                }


              });
            }

          } else {
            if (action == 'new') {
              let emptyItems = this.fileds.filter(item => resetField.includes(item.name));
              emptyItems.forEach(item => {
                item["id"] = "";
              });
            }
          }
        });
      }
      if (fieldname) {
        // let isShowReq = [];
        const selObject = this.fileds.find(item => item.name === fieldname);
        let groupvisible = [];
        let isShowHide = [];
        let isReqNon = [];


        if (selObject && selObject["string-array"] && selObject["string-array"].filter(item => Object.prototype.hasOwnProperty.call(item, 'visibleItem'))) {
          groupvisible = selObject["string-array"].find(item => item.id == districtid);
          if (groupvisible) {
            if (groupvisible['visibleItem']) {
              isShowHide.push("show:" + groupvisible['visibleItem']);
            }
            if (groupvisible['hideItem']) {
              isShowHide.push("hide:" + groupvisible['hideItem']);
            }
            if (groupvisible['requiredItem']) {
              isReqNon.push("required:" + groupvisible['requiredItem']);
            }
            if (groupvisible['nonRequiredItem']) {
              isReqNon.push("nonrequired:" + groupvisible['nonRequiredItem']);
            }

            isShowHide.forEach(change => {
              const [action, fieldNames] = change.split(':');
              const affectedFields = fieldNames.split(',');


              this.fileds.forEach(field => { // Accessing fields from 'this' object
                if (affectedFields.includes(field.name)) {
                  field.visible = (action === 'show') ? 1 : 0;
                  // console.log(field.name, field.visible);
                }
              });
            });

            isReqNon.forEach(change => {
              const [action, fieldNames] = change.split(':');
              const requiredFields = fieldNames.split(',');
              this.fileds.forEach(field => { // Accessing fields from 'this' object
                if (requiredFields.includes(field.name)) {
                  field.required = (action === 'required') ? 1 : 0;
                  // console.log(field.name, field.visible);
                }
              });
            });
          }
        } else {
          console.log("Either 'sel' is undefined/null, 'string-array' property does not exist, or none of the items in 'string-array' have the key 'visible'.");
        }

        // let selObject = this.originalFieldsData.filter(sel => {
        //   return resetField.includes(sel.name) && sel.fieldType === 'Spinner';
        // });
        // console.log(selObject['fieldType']);
        // console.log('selObject',selObject);
        //
        // alert('dfnjf');

        // if (selObject && selObject["string-array"]) {
        //   alert('in')["string-array"]
        // console.log('selObject',selObject)
        // selObject.forEach(sel => {
        //   if (sel && sel) {
        //     const filteredArray = sel["string-array"].filter(item => districtid.includes(item.id));
        //     console.log('filename',filteredArray);
        //
        //   }
        //
        // });

      }
      // const companyItem = this.originalFieldsData['string-array']?.find(item => item.name == fieldname && 'visibleItem' in item);
      // const hasVisibleItem = this.originalFieldsData['string-array']?.find(item => 'visibleItem' in item);
      // const hasVisibleItem = this.originalFieldsData["string-array"]?.find(item => Object.prototype.hasOwnProperty.call(item, 'visibleItem'));
      // const hasVisibleItem = this.originalFieldsData["string-array"]?.some(item => Object.prototype.hasOwnProperty.call(item, 'id'));
//       const hasIdKey = this.originalFieldsData["string-array"]?.some(item => Object.prototype.hasOwnProperty.call(item, 'id'));
//
//       if (hasVisibleItem) {
//         console.log("At least one item in 'string-array' has the key 'visibleItem'.");
//
// alert('yes');
//       }
//       else{

      // }


      visibilityChanges.forEach(change => {
        const [action, fieldNames] = change.split(':');
        const affectedFields = fieldNames.split(',');


        this.fileds.forEach(field => { // Accessing fields from 'this' object
          if (affectedFields.includes(field.name)) {
            field.visible = (action === 'show') ? 1 : 0;
            // console.log(field.name, field.visible);
          }
        });
      });
      requiredChanges.forEach(change => {
        const [action, fieldNames] = change.split(':');
        const affectedFields = fieldNames.split(',');


        this.fileds.forEach(field => { // Accessing fields from 'this' object
          if (affectedFields.includes(field.name)) {
            field.required = (action === 'required') ? 1 : 0;

          }
        });
      });

      if (autoReflectField != '') {
        let mainField = this.originalFieldsData.find(item => item.name == fieldname);
        // console.log('shiny',mainField);
        // alert('mainField');
        // alert(fieldname);

        if (mainField) {
          const filteredArray = mainField["string-array"].filter(sel => sel.id == districtid);


          if (filteredArray.length > 0) {
            const skills = filteredArray[0].skills.split(',').map(skill => parseInt(skill.trim(), 10));
            // const skillitem = this.originalFieldsData.find(item => item.name === autoReflectField);
            // console.log(skills);
            // console.log(autoReflectField);
            this.fileds.find(item => item.name === autoReflectField)["id"] = skills;

          }
          // else {
          //   console.log("No item found with the given district ID.");
          // }
        }

      }

    },


    stripTags(html) {
      // Regular expression to remove HTML tags
      return html.replace(/<[^>]+>/g, '');
    },

    async formconfirm() {

      this.confirmModal = true;
      // if (!this.submitClickedEmitted) {
      //   this.submitClickedEmitted = true;
      //   // console.log('SubmitDATA',this.fileds);
      // }
      // let transformedArray = {};
      // this.fileds.forEach(obj => {
      //   transformedArray[obj.name] = obj.id;
      // });
      // console.log(transformedArray);
      // const RegisterData = await callAxiosWithConfig("https://jobspro.nithrajobs.com/api/register/form/submit", transformedArray, 'post');
      // console.log(RegisterData);
    },


    async updateDataArray({key, value}) {
      // this.$set(this.DataArray, updatedFieldData.name, updatedFieldData.value);
      this.$set(this.DataArray, key, value);

      try {
        // alert(1);
        const RegisterData = await callAxiosWithConfig("https://jobspro.nithrajobs.com/api/post/form/submit", this.DataArray, 'post');
        console.log(RegisterData)
        //
        // this.$bvModal.hide('modal-center');
        // // alert('kkkk')
        //
        // const inputString = RegisterData.activity;
        // const lastPart = inputString.split('.').pop();
        // this.urlData = RegisterData.url;
        // // alert(lastPart)
        //
        // if (lastPart === 'ViewCandidate_List') {
        //
        //   console.log('qsdx')
        //
        //   const url = this.urlData;
        //   const parsedUrl = new URL(url);
        //   const desiredPath = parsedUrl.pathname.slice(13).replace(/\//g, '-');
        //   const encryptedString = this.Encrypt(desiredPath);
        //   console.log(desiredPath)
        //   window.location.href = `/viewed-employer-list${parsedUrl.search}&page=${encryptedString}`;
        //
        // }else if(lastPart === 'Employer_Dynamic_Home_Activity'){
        //   const url = 'post/view/dashboard'
        //   const parsedUrl = url;
        //   const encryptedString = this.Encrypt(parsedUrl);
        //   window.location.href = `/view-post?page=` + encryptedString;
        // }


        // console.log(RegisterData.title);

      } catch (error) {
        // alert(2);
        console.error('Error in Axios request:', error);
      }

    },


    toggleSidebar() {
      this.sidebar = !this.sidebar
    },

    tagValidator(tag) {
      // Individual tag validator function
      // console.log(tag)


      const numericRegex = /^[0-9]+$/;
      // console.log(numericRegex.test(tag))
      //
      if (numericRegex.test(tag)) {
        return tag === tag.toLowerCase() && tag.length >= 10 && tag.length <= 10
      } else {
        return false;
      }


      // return tag === numericRegex.test(tag) && tag.length >= 10 && tag.length <= 10;
    },

  }


}
</script>

<style>
.focused {
  /* Add your highlight styles here */
  border: 2px solid blue;
}

.appie-features-box-item {
  padding: 10px 12px 12px 10px !important;
}

.appie-features-box-item.item-2:hover {
  border-color: unset;
}

.formcard {
  width: 100%;
  margin: auto;
}

@media (min-width: 768px) {
  .formcard {
    width: 50% !important;
    margin: auto;
  }
}

@media only screen and (max-width: 299px) {
  .cardDiv {
    position: fixed;
    z-index: 1;
    bottom: 0;
    left: 0;
  }

  .buttonDiv {
    left: 30%;
    position: relative;
  }
}

@media (min-width: 300px) and (max-width: 399px) {

  .cardDiv {
    position: fixed;
    bottom: 0;
    z-index: 1;
    left: 0;
  }

  .buttonDiv {
    left: 35%;
    position: relative;
  }

  .custom-toast-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 100vh;
    margin: 0;
  }

  .toasted-container .toasted {
    margin: 0 auto;
    width: 50%;
  }

}

@media (min-width: 400px) and (max-width: 499px) {
  .cardDiv {
    position: fixed;
    bottom: 0;
    z-index: 1;
  }

  .buttonDiv {
    left: 35%;
    position: relative;
  }
}

@media (min-width: 500px) and (max-width: 599px) {
  .cardDiv {
    position: fixed;
    bottom: 0;
    z-index: 1;
    left: 0;
  }

  .buttonDiv {
    left: 36%;
    position: relative;
  }
}

/* Extra small devices (phones, 600px and down) */


/* Small devices (portrait tablets and large phones, 600px and up) */
@media (min-width: 600px) and (max-width: 767px) {
  .temp_10 {
    min-height: 100px;
    border: unset;
    width: 100%;
    border-radius: 10px;
  }

  .temp_10_space {
    margin-bottom: 30px;
  }

  .imageSize {
    width: 10%;
  }

  .cardDiv {
    position: fixed;
    bottom: 0;
    z-index: 1;
    left: 0;
  }

  .buttonDiv {
    left: 36%;
    position: relative;
  }
}

@media (min-width: 768px) and (max-width: 800px) {
  .cardDiv {
    position: fixed;
    bottom: 0;
    z-index: 1;
    left: 0;
  }

  .buttonDiv {
    left: 43%;
    position: relative;
  }
}

@media (min-width: 801px) and (max-width: 991px) {
  .cardDiv {
    position: fixed;
    bottom: 0;
    z-index: 1;
    left: 0;
  }

  .buttonDiv {
    left: 43%;
    position: relative;
  }
}

/* Medium devices (landscape tablets, 768px and up) */

/* Large devices (laptops/desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1024px) {
  .cardDiv {
    position: fixed;
    bottom: 0;
    z-index: 1;
    left: 0;
  }

  .buttonDiv {
    left: 43%;
    position: relative;
  }
}


/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .temp_10 {
    border: unset;
    width: 100%;
    min-height: 200px;
    border-radius: 10px;

  }

  .text_space {
    margin-top: 10px;
  }

  .imageSize {
    width: 4%;
  }

}

@media only screen and (min-width: 1201px) {
  .cardDiv {
    position: fixed;
    bottom: 0;
    z-index: 1;
    left: 0;
  }


  .buttonDiv {
    left: 43%;
    position: relative;
  }
}


#data {
  display: flex;
}

.value-button {
  cursor: pointer;
  margin: -3px 0px 0px 0px;
  border-radius: 0 8px 8px 0;
  width: 40px;
  height: 40px;
//background-color: green; border-color: #f38b28; display: flex; align-items: center; justify-content: center;
}

.decrease {
  margin: -3px -2px 0px 25px;
  border-radius: 25px 0 0 25px;
  width: 15%;
  border: 3px solid #908484;

}

.increase {
  border-radius: 0px 25px 25px 0px;
  margin-left: 5px; /* Adjust the margin between buttons */
  width: 15%;
  border: 3px solid #908484;

}

.value-button.active {
//background-color: #f38b28;
}

.vs__dropdown-menu {
//display: none; border: none; padding: 10px 10px 10px 10px;
}

.b-form-tag > button.b-form-tag-remove {
  background: blueviolet;
  width: 20px;
}

.b-form-tag-content {
  background-color: #dd7c69;
  width: 90px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
}


.modal-content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.centered-content {
  margin-bottom: 20px; /* Adjust the margin as needed */
}

.langbtn {
  width: 100px;
  margin: 0px 2px;
  border-radius: 10px;
  padding: 5px;
  border: unset;
}

.backbtn {
  font-size: 23px;
  /* width: 100px; */
  /* margin: 0px 2px; */
  border-radius: 10px;
//padding: 0px 10px;
  border: unset;
//background: #0e1133;
}

</style>
